import { render } from "./AsignarModal.vue?vue&type=template&id=435d2ae8&scoped=true"
import script from "./AsignarModal.vue?vue&type=script&lang=js"
export * from "./AsignarModal.vue?vue&type=script&lang=js"

import "./AsignarModal.vue?vue&type=style&index=0&id=435d2ae8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435d2ae8"]])

export default __exports__